import { z } from 'zod';

import { ProseMirrorJSONSchema } from './ProseMirrorJSONSchema';
import { BaseQuestionWidgetSchema } from './QuestionBaseSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export enum ScrambleMode {
  SameForAll = 'sameForAll',
  RandomForEach = 'randomForEach'
}

const WordOptionSchema = z.object({
  id: z.string(),
  value: z.string()
});

export const FillInTheBlanksQuestionWidgetStaticSchema = BaseQuestionWidgetSchema(
  WidgetType.FillInTheBlanksQuestion
).extend({
  /**
   * ProseMirror JSON
   */
  answerFragment: ProseMirrorJSONSchema,
  answerPlaceholder: z.string().optional(),
  saveAnswers: z.boolean(),
  scrambleMode: z.nativeEnum(ScrambleMode),
  scrambledWordBankOptionsOrder: z.array(z.string()),
  wordBankOptions: z.array(WordOptionSchema)
});

export type FillInTheBlanksQuestionWidgetStaticSchema = z.infer<typeof FillInTheBlanksQuestionWidgetStaticSchema>;
